import mathString from 'math-string'

blue.ready('calculator_interactions', '.calculator', calc => {
	const calculator = calc.querySelector('.calculator-calc')
	const toggles = [...calc.querySelectorAll('.calculator-drawerTrigger')]
	const tabs = [...calc.querySelectorAll('.calculator-tab')]
	const contents = [...calc.querySelectorAll('.calculator-tabContent')]
	let drawer

	const cleanUp = function(e) {
		if (e.propertyName === 'height') {
			this.style.height = ''
			this.removeEventListener('transitionend', cleanUp)
		}
	}

	const changeTab = function(e) {
		let index = tabs.indexOf(this)
		let height = calculator.offsetHeight
		let newHeight

		tabs.forEach(tab => tab.classList.remove('is-active'))
		contents.forEach(cont => cont.classList.remove('is-active'))

		this.classList.add('is-active')
		contents[index].classList.add('is-active')

		calculator.style.transition = 'none'
		newHeight = calculator.offsetHeight
		calculator.style.transition = ''
		calculator.style.height = `${height}px`

		setTimeout(() => {
			calculator.style.height = `${newHeight}px`
			calculator.addEventListener('transitionend', cleanUp)
		})
	}

	const toggleAdvanced = function(e) {
		let height
		drawer = this.closest('.calculator-drawer').querySelector('.calculator-inputs')

		if (this.classList.contains('is-active')) {
			this.classList.remove('is-active')
			drawer.style.overflow = "hidden"
			drawer.style.height = 0
		}
		else {
			this.classList.add('is-active')
			drawer.style.height = 'auto'
			height = drawer.offsetHeight
			drawer.style.height = 0

			setTimeout(() => {
				drawer.style.height = `${height}px`
				drawer.style.overflow = "visible"
			})
		}
	}

	toggles.forEach(toggle => toggle.addEventListener('click', toggleAdvanced))
	tabs.forEach(tab => tab.addEventListener('click', changeTab))
})



blue.ready('calculator_calculate', '.calculator-tabContent', calc => {
		const inputs = [...calc.querySelectorAll('input, select')]
		const results = [...calc.querySelectorAll('[data-formula]')]
		const patt = /(#[a-z]+)/gm
		
		const calculation = function(e) {
			if (e) e.stopPropagation()
			results.forEach(result => {
				if (!result.getAttribute('data-formula')) return
				let formula = result.getAttribute('data-formula')
				let ids = formula.match(patt)
				let values = {}

				ids.forEach(id => {
					inputs.forEach(input => {
						if (input.getAttribute('data-val') == id.slice(1)) {
							values[id] = parseFloat(input.value.replace(/,/g, '')) || 0
						}
					})
					results.forEach(result => {
						if (result.getAttribute('data-val') == id.slice(1)) {
							values[id] = parseFloat(result.querySelector('.calculator-totalValueNumber').innerText.replace(/,/g, '')) || 0
						}
					})
				})

				formula = formula.replace(patt, (match) => {
					if (values.hasOwnProperty(match)) {
						return values[match]
					}
				})

				formula = formula.replace(/\*\*/g, '^')
				try {
					result.querySelector('.calculator-totalValueNumber').innerText = mathString(formula) == 0 ? '--' : blue.meth.formatMoney(mathString(formula))
				}
				catch(err) {
					console.log(err)
					result.querySelector('.calculator-totalValueNumber').innerText = '--'
				}
			})
		}

		inputs.forEach(input => input.addEventListener('input', calculation))
		inputs.forEach(input => input.addEventListener('change', calculation))
		calculation()
});